import reportHubFullcont from "./reportHub-fullcont.html";

const dbRequest = require("../../../../../js-network/db-request");
const fullcont = require("../../../../../components/fullcont/fullcont");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const { form, formCopy } = require("./reportHub-fullcont-form");
const jumperHandler = require("./reportHub-fullcont-jumper-handler");

const REPORT_HTML_ENDPOINT = "server/php/report/report-html.php";

let HTMLwasSelected = false;
let requesting = false;
const htmlFc = {};

function HTMLselect() {
  fullcontHandler.HTMLselect(
    "reportHub",
    "reportHub",
    "reportHub-fullcont",
    reportHubFullcont,
    form,
    formCopy,
    undefined,
    readOnlyAction,
    readOnlyAction,
    undefined,
    htmlFc
  );

  // ReportHub starts from Dashboard. Keep its normal fullcont lifecycle,
  // but place the container inside the page that is currently visible.
  const dashboardPage = document.getElementById("dashboard-page");
  if (dashboardPage !== null) dashboardPage.appendChild(htmlFc.fullcontHTML);

  htmlFc.selectOne = REPORT_HTML_ENDPOINT;
  htmlFc.fullcontHTML.classList.add("mode-view", "mode-readOnly");
  HTMLwasSelected = true;
}

function readOnlyAction() {
  return false;
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect();

  const action = obj[detail.act];
  if (action) return action.start(detail);
}

const obj = {
  hide: {
    start: detail => fullcontEntity.hide(detail, htmlFc),
  },
  jumperToSale: {
    start: detail => jumperHandler.jumperToSale(detail),
  },
  jumperToPurchase: {
    start: detail => jumperHandler.jumperToPurchase(detail),
  },
  jumperToCustomer: {
    start: detail => jumperHandler.jumperToCustomer(detail),
  },
  jumperToProvider: {
    start: detail => jumperHandler.jumperToProvider(detail),
  },
  jumperToItem: {
    start: detail => jumperHandler.jumperToItem(detail),
  },
  selectOne: {
    start: detail => selectOne(detail),
  },
};

async function selectOne(detail) {
  if (requesting || !detail.definition) return;

  requesting = true;

  try {
    const result = await dbRequest.start(
      {
        inf: {
          entity: detail.definition.entity,
          reportName:
            detail.definition.htmlReportname ||
            detail.definition.reportname ||
            detail.definition.id,
          filters: JSON.stringify(detail.filters || {}),
        },
      },
      htmlFc.selectOne
    );

    if (result.status !== "ok") return;

    const reportContainer = htmlFc.fullcontHTML.querySelector("#reportHub-fullcont-report");
    const title = htmlFc.fullcontHTML.querySelector("#reportHub-fullcont-title");

    reportContainer.innerHTML = result.data?.[0]?.html || "";
    title.textContent = detail.definition.label || "Report View";

    fullcontHandler.prepareView(form, { id: "reportHub-fullcont" });
    fullcont.start({
      act: "pageMov",
      id: "reportHub-fullcont",
      fullcontHTML: htmlFc.fullcontHTML,
      pagetoshow: "entity",
    });
    fullcont.start({
      act: "show",
      id: "reportHub-fullcont",
      fullcontHTML: htmlFc.fullcontHTML,
    });
  } finally {
    requesting = false;
  }
}
